import { ICustomIconProps } from './types';

const IconTLogo: React.FC<ICustomIconProps> = ({ size = 20, color = '#9F9F9F', className }) => {
  // Calculate height based on the original SVG aspect ratio (18/20)
  const height = size * (18 / 20);

  return (
    <svg width={size} height={height} viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M1.7653 6.73459V2.58923C1.76541 2.49118 1.80546 2.39717 1.87665 2.32783C1.94784 2.2585 2.04436 2.2195 2.14504 2.2194H6.49013V0.5H2.14504C1.57633 0.500625 1.03109 0.720942 0.628958 1.11262C0.226823 1.50429 0.000628566 2.03533 0 2.58923V6.73459H1.7653Z'
        fill={color}
      />
      <path
        d='M1.7653 15.4108V11.0227H0V15.4108C0.000628566 15.9647 0.226823 16.4957 0.628958 16.8874C1.03109 17.279 1.57633 17.4994 2.14504 17.5H6.49013V15.7806H2.14504C2.04435 15.7805 1.94783 15.7415 1.87664 15.6722C1.80545 15.6028 1.76541 15.5088 1.7653 15.4108Z'
        fill={color}
      />
      <path
        d='M18.2349 2.58917V6.73453H20.0002V2.58917C19.9996 2.03528 19.7734 1.50425 19.3712 1.11259C18.9691 0.720934 18.4239 0.500625 17.8552 0.5H13.1363V2.21933H17.8552C17.9559 2.21944 18.0524 2.25843 18.1236 2.32777C18.1948 2.3971 18.2348 2.49111 18.2349 2.58917Z'
        fill={color}
      />
      <path
        d='M18.2349 11.0229V15.411C18.2348 15.5091 18.1948 15.6031 18.1236 15.6724C18.0524 15.7418 17.9559 15.7808 17.8552 15.7809H13.1363V17.5002H17.8552C18.4239 17.4996 18.9691 17.2793 19.3713 16.8876C19.7734 16.4959 19.9996 15.9649 20.0002 15.411V11.0229H18.2349Z'
        fill={color}
      />
      <path d='M6.50308 3.91522H3.60938V6.73358H6.50308V3.91522Z' fill={color} />
      <path d='M11.2919 3.91504H8.39817V6.73339H11.2919V3.91504Z' fill={color} />
      <path d='M11.2919 8.36572H8.39817V11.1841H11.2919V8.36572Z' fill={color} />
      <path d='M11.1825 12.8525H8.2888V15.6709H11.1825V12.8525Z' fill={color} />
      <path d='M16.03 3.91504H13.1363V6.73339H16.03V3.91504Z' fill={color} />
    </svg>
  );
};

export default IconTLogo;
